export const messages = {
  en: {
    addPurchaseApply: {
      purchaser: 'Purchaser',
      return: 'Return',
      warehouse: 'Warehouse',
      requiredSelectWarehouse: 'Required, please select warehouse',
      contact: 'Contact',
      requiredContact: 'Required, please enter contact',
      phone: 'Phone',
      requiredPhone: 'Required, please enter phone',
      applyDesc: 'Application Description',
      requiredDesc: 'Required, please enter description',
      purchaseItems: 'Purchase Items',
      select: 'Select',
      itemType: 'Item Type',
      itemNameCode: 'Item Name(Code)',
      itemSpec: 'Item Specification',
      price: 'Price',
      selectPrice: 'Please select price',
      itemStock: 'Item Stock',
      applyQuantity: 'Apply Quantity',
      requiredQuantity: 'Required, please enter quantity',
      remark: 'Remark',
      optionalRemark: 'Optional, please enter remark',
      operation: 'Operation',
      remove: 'Remove',
      approver: 'Approver',
      requiredApprover: 'Required, please select approver',
      submit: 'Submit',
      noItemsSelected: 'No items selected!',
      sameWarehouseRequired: 'Purchased items must come from the same warehouse!',
      selectPriceRequired: 'Please select price!',
      quantityRequired: 'Please enter quantity!',
      selectWarehouseRequired: 'Please select warehouse!',
      contactRequired: 'Please enter contact!',
      phoneRequired: 'Please enter phone!',
      descRequired: 'Please enter description!'
    },
    chooseResourceStore2: {
      title: '[Item Collection/Purchase Application/Direct Outbound] Select Items',
      selectWarehouse: 'Please select warehouse',
      selectItemType: 'Please select item type',
      selectSubType: 'Please select sub type',
      inputItemName: 'Enter item management name',
      warehouse: 'Warehouse',
      itemType: 'Item Type',
      itemName: 'Item Name',
      itemSpec: 'Item Specification',
      itemCode: 'Item Code',
      fixedItem: 'Fixed Item',
      itemPrice: 'Item Price',
      itemStock: 'Item Stock',
      selectItemsRequired: 'Please select items to purchase'
    },
  },
  zh: {
    addPurchaseApply: {
      purchaser: '采购人',
      return: '返回',
      warehouse: '仓库',
      requiredSelectWarehouse: '必填，请选择仓库',
      contact: '联系人',
      requiredContact: '必填，请填写联系人',
      phone: '联系电话',
      requiredPhone: '必填，请填写联系电话',
      applyDesc: '申请说明',
      requiredDesc: '必填，请填写申请说明',
      purchaseItems: '采购物品',
      select: '选择',
      itemType: '物品类型',
      itemNameCode: '物品名称(编码)',
      itemSpec: '物品规格',
      price: '价格',
      selectPrice: '请选择价格',
      itemStock: '物品库存',
      applyQuantity: '申请数量',
      requiredQuantity: '必填，请填写申请数量',
      remark: '备注',
      optionalRemark: '选填，请填写备注',
      operation: '操作',
      remove: '移除',
      approver: '审批人',
      requiredApprover: '必填，请选择审批人',
      submit: '提交',
      noItemsSelected: '未选择采购物品！',
      sameWarehouseRequired: '采购商品需来自同一仓库！',
      selectPriceRequired: '请选择价格！',
      quantityRequired: '请填写申请数量！',
      selectWarehouseRequired: '请选择仓库！',
      contactRequired: '请填写联系人！',
      phoneRequired: '请填写联系电话！',
      descRequired: '请填写申请说明！'
    },
    chooseResourceStore2: {
      title: '【物品领用/采购申请/直接出库】选择物品',
      selectWarehouse: '请选择仓库',
      selectItemType: '请选择物品类型',
      selectSubType: '请选择二级分类',
      inputItemName: '输入物品管理名称',
      warehouse: '仓库',
      itemType: '物品类型',
      itemName: '物品名称',
      itemSpec: '物品规格',
      itemCode: '物品编码',
      fixedItem: '固定物品',
      itemPrice: '物品价格',
      itemStock: '物品库存',
selectItemsRequired: '请选择需要采购的物品'
    },
  },
  'zh-TW': {
    addPurchaseApply: {
      purchaser: '採購人',
      return: '返回',
      warehouse: '倉庫',
      requiredSelectWarehouse: '必填，請選擇倉庫',
      contact: '聯絡人',
      requiredContact: '必填，請填寫聯絡人',
      phone: '聯繫電話',
      requiredPhone: '必填，請填寫聯繫電話',
      applyDesc: '申請說明',
      requiredDesc: '必填，請填寫申請說明',
      purchaseItems: '採購物品',
      select: '選擇',
      itemType: '物品類型',
      itemNameCode: '物品名稱(編碼)',
      itemSpec: '物品規格',
      price: '價格',
      selectPrice: '請選擇價格',
      itemStock: '物品庫存',
      applyQuantity: '申請數量',
      requiredQuantity: '必填，請填寫申請數量',
      remark: '備註',
      optionalRemark: '選填，請填寫備註',
      operation: '操作',
      remove: '移除',
      approver: '審批人',
      requiredApprover: '必填，請選擇審批人',
      submit: '提交',
      noItemsSelected: '未選擇採購物品！',
      sameWarehouseRequired: '採購商品需來自同一倉庫！',
      selectPriceRequired: '請選擇價格！',
      quantityRequired: '請填寫申請數量！',
      selectWarehouseRequired: '請選擇倉庫！',
      contactRequired: '請填寫聯絡人！',
      phoneRequired: '請填寫聯繫電話！',
      descRequired: '請填寫申請說明！'
    },
    chooseResourceStore2: {
      title: '【物品領用/採購申請/直接出庫】選擇物品',
      selectWarehouse: '請選擇倉庫',
      selectItemType: '請選擇物品類型',
      selectSubType: '請選擇二級分類',
      inputItemName: '輸入物品管理名稱',
      warehouse: '倉庫',
      itemType: '物品類型',
      itemName: '物品名稱',
      itemSpec: '物品規格',
      itemCode: '物品編碼',
      fixedItem: '固定物品',
      itemPrice: '物品價格',
      itemStock: '物品庫存',
      selectItemsRequired: '請選擇需要採購的物品'
    },
  }
}